import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';

//PAGES
import { EntregasPage } from '../entregas/entregas';
import { PedidoPage } from '../pedido/pedido';
import { ConferenciaPage } from '../conferencia/conferencia';

//PROVIDERS
import { Services, Tools, Tracking, SyncIO } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-view-entrega',
  templateUrl: 'view-entrega.html',
})
export class ViewEntregaPage {
  entrega:any;
  pedidos:any=[];
  textButton:string='Iniciar Rota';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl:AlertController,
    private services: Services,
    private tools: Tools,
    private sync: SyncIO,
    private tracking: Tracking
  ){}

  ionViewDidLoad(){
    var loading = this.tools.showLoading('Carregando...');
    loading.present();
    this.entrega = this.navParams.get('item');
    let query = {ativo:true,id:{$in:this.entrega.pedidosId}}

    this.services.getData('cadPedidos',query,(result)=>{
      var newdata = result.data.map(e=>{
        e.order = this.entrega.pedidosId.indexOf(e.id)
        return e;
      });
      this.pedidos = newdata.sort((a, b)=>{
        if(a.order > b.order){return 1}
        if(a.order < b.order){return -1}
        return 0;
      });
      this.buttonText();
      loading.dismiss();
    });
  }

  stopTracking(){
    // this.tracking.stop();
  }

  ionViewDidEnter(){
    if(!this.entrega.conferencia){
      this.navCtrl.push(ConferenciaPage,{item:this.entrega});
      return
    }
  }

  buttonText(){
    this.textButton = 'Próxima Rota';
    if(this.pedidos.length==0){return}
    var pedido = this.pedidos.find(e=>['Ocorrência','Em Andamento','Entrega Liberada'].indexOf(e.entrega.status)>=0);
    var totalFinalizado = this.pedidos.filter(e=>e.entrega.status == 'Finalizado' || e.entrega.status == 'Ocorrência').length;
    var totalPedidos = this.pedidos.length;

    if(pedido.entrega.status == 'Entrega Liberada'){
      this.textButton = 'Iniciar Rota';
      if(totalFinalizado>0){
        this.textButton = 'Próxima Rota';
      }
    }else{
      this.textButton = 'Finalizar Rota';
    }
  }

  teste2(){
    var pedido = this.pedidos.find(e=>['Ocorrência','Em Andamento','Entrega Liberada'].indexOf(e.entrega.status)>=0 && !e.entrega.finalizado);
    this.tracking.start(pedido,this.entrega);
  }
  teste3(){
    this.tracking.stop();
  }


  openWaze(){
    var loading = this.tools.showLoading('Carregando...');
    loading.present();
    var pedido = this.pedidos.find(e=>['Ocorrência','Em Andamento','Entrega Liberada'].indexOf(e.entrega.status)>=0 && !e.entrega.finalizado);

    if(pedido.entrega.status == 'Entrega Liberada'){
      this.tracking.stop();
      this.tracking.start(pedido,this.entrega);
      pedido.entrega.status = 'Em Andamento';
      pedido.entrega.inicioEntrega = new Date().getTime();
      if(this.entrega.inicioEntrega == 0){
        this.entrega.inicioEntrega = new Date().getTime();
      }
      this.entrega.statusText = 'Em Andamento';
      this.entrega.status = 'primary';

      // loading.dismiss();
      this.saveAll(pedido,this.entrega,loading);
      this.buttonText();
      window.open('geo:0,0?q='+pedido.position.lat+','+pedido.position.lng, '_system');
    }else if(pedido.entrega.status == 'Ocorrência'){
      pedido.entrega.finalizado = true;
      pedido.entrega.fimEntrega = new Date().getTime();
      this.finalizarOcorrencia(pedido,loading);
    }else{
      console.log(pedido);
      console.log(this.entrega);

      let alert = this.alertCtrl.create({
        title: 'Informações recebedor',
        enableBackdropDismiss:false,
        inputs: [
          {
            name: 'recebedor',
            placeholder: 'Nome Recebedor'
          },
          {
            name: 'documento',
            placeholder: 'Documento Recebedor',
          }
        ],
        buttons: [
          {
            text: 'Cancelar',
            handler: data => {
              loading.dismiss();
              return;
            }
          },
          {
            text: 'OK',
            handler: data => {
              pedido.entrega.recebedorNome = data.recebedor+'';
              pedido.entrega.recebedorDoc = data.documento+'';
              this.finalizar(pedido,loading);
            }
          }
        ]
      });
      alert.present();
    }
  }

  finalizar(pedido:any,loading:any){
    this.tools.openCamera(result=>{
      if(!result){loading.dismiss();return;}

      var postObj = {
        metadata : {
          collection : "fileConfirmacoes",
          linkId : pedido._id+'',
          filename : pedido._id+".jpg"
        },
        positId:pedido._id+'',
        base64:result+''
      }

      this.tracking.stop();

      this.services.saveImg('',postObj,(result)=>{
        if(pedido.entrega.status != 'Ocorrência'){
          pedido.entrega.status = 'Finalizado';
          pedido.entrega.fimEntrega = new Date().getTime();
        }
        var totalPedidos = this.pedidos.length;
        var totalFinalizado = this.pedidos.filter(e=>e.entrega.status == 'Finalizado' || e.entrega.status == 'Ocorrência').length;
        if(totalPedidos == totalFinalizado){
          this.entrega.fimEntrega = new Date().getTime();
          this.entrega.status = 'success';
          this.entrega.statusText = 'Finalizada';
        }

        loading.dismiss();

        this.tracking.stop();
        this.saveAll(pedido,this.entrega,loading);
        this.buttonText();
      });
    });
  }

  finalizarOcorrencia(pedido:any,loading:any){
    var totalPedidos = this.pedidos.length;
    var totalFinalizado = this.pedidos.filter(e=>e.entrega.status == 'Finalizado' || e.entrega.status == 'Ocorrência').length;
    if(totalPedidos == totalFinalizado){
      this.entrega.fimEntrega = new Date().getTime();
      this.entrega.status = 'success';
      this.entrega.statusText = 'Finalizada';
    }

    this.tracking.stop();
    this.saveAll(pedido,this.entrega,loading);
    this.buttonText();
  }

  saveAll(pedido:any,entrega:any,loading:any){
    this.entrega.progresso = this.pedidos.filter(e=>['Finalizado','Ocorrência'].indexOf(e.entrega.status)>=0).length+'/'+entrega.pedidosId.length;
    this.services.save('cadPedidos',pedido,(result)=>{
      this.services.save('cadRotas',entrega,(result)=>{
        let obj = {
          pedidoId:pedido._id,
          entregaId:entrega._id,
          time:new Date().getTime()
        }

        this.sync.send(obj,'updRota');

        var totalPedidos = this.pedidos.length;
        var totalFinalizado = this.pedidos.filter(e=>e.entrega.status == 'Finalizado' || e.entrega.status == 'Ocorrência').length;
        if(totalPedidos == totalFinalizado){
          this.tools.showAlert('toast','Entrega finalizada com sucesso!');
          this.navCtrl.setRoot(EntregasPage);
        }
        loading.dismiss();
      });
    });
  }

  openPedido(pedido:any){
    this.navCtrl.push(PedidoPage,{item:{pedido:pedido,entrega:this.entrega}});
  }
}



// WEBPACK FOOTER //
// ./src/pages/view-entrega/view-entrega.ts